import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Grid from '@material-ui/core/Grid';

import { AppConfig } from '../AppConfig';
import { CommonStyles } from '../styles/Styles';
import Icon from '@material-ui/core/Icon';
import { Button, Divider } from '@material-ui/core';
import { data } from '../data/AdminData.js'
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Link } from 'react-router-dom';
import { ApiHelper } from '../common/helpers/ApiHelper';
import { UiHelper } from '../common/helpers/UiHelper';
import InputLabel from '@material-ui/core/InputLabel';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import momentTz from 'moment-timezone';
import { DateTimePicker, MuiPickersUtilsProvider, DatePicker } from 'material-ui-pickers'; //NOTE: made changes in lib corresponding to the issue: https://github.com/viict/material-ui-pickers/commit/96af9c855df51fc0b96a9bd6f7b22684d47a7043
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { EventList } from '../common/components/EventList';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import IconButton from '@material-ui/core/IconButton';
import { EventDialogFunction } from '../common/components/EventDialogFunction';
import { FileDownloadService } from '../common/helpers/FileDownloadService';
import { ApiHelperV2 } from '../common/helpers/ApiHelperV2';
import { Helper } from '../common/helpers/Helper';
import { Controller } from '../common/Controller';
import { AppTheme } from '../styles/AppTheme';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import CircularProgress from '@material-ui/core/CircularProgress';
import { AppHelper } from '../helpers/AppHelper.js'

export class Reports extends Component {
  constructor(props) {
    super(props);
    this.reportData = data
    this.eventsLimit = AppConfig.eventQueryLimit;
    this.userSettings = Controller.get().userMgrV2().getUserSettings()
    this.eventPriorityValue = Number(this.userSettings.EVENT_VISIBILITY);
    this.slug = this.props.match.params.id ? this.props.match.params.id : null;
    this.state = {
      pageNumber: 0,
      eventsReady: false,
      eventData: [],
      eventDataMain: [],
      cams: [],
      selectedCam: null,
      selectedCamId: '',
      eventFields: [],
      eventFieldLabel: [],
      fromEventDate: moment().subtract(1, 'days').valueOf(),
      toEventDate: moment().valueOf(),
      eventPriorities: [],
      eventImages: [],
      downloadDialog: false,
      eventIndex: 0,
      dialogEdit: null,
      fetchState: ApiHelperV2.State.LOADING,
      paginate: false,
      selectedEvent: []
    },
    this.reportFields = {
      selectCam: {
        key: 'selectedCamId',
        label: 'Select Cam',
        type: 'text'
      },
      eventFields: {
        key: 'eventFields',
        label: 'Event fields',
        labelValue: 'eventFieldLabel',
        type: 'text'
      },
      eventPriorities: {
        key: 'eventPriorities',
        label: 'Event Priorities',
        type: 'text'
      },
      eventImages: {
        key: 'eventImages',
        label: 'Event Images',
        type: 'text'
      },
      fromEventDate: {
        key: 'fromEventDate',
        label: 'From',
        type: 'text'
      },
      toEventDate: {
        key: 'toEventDate',
        label: 'To',
        type: 'text'
      },
    },
    this.pdfAttrColWidth = {
      camId: 80,
      //_id: 70,
      // eslint-disable-next-line camelcase
      event_time: 120,
      //image: 70,
      name: 90,
      type: 90,
      priority: 5,
      priorityReported: 5,
    }
  }

  render() {
    if (this.state.fetchState === ApiHelper.State.LOADING) {
      return UiHelper.componentLoadingView();
    } else if (this.state.fetchState === ApiHelper.State.ERROR) {
      return UiHelper.errorView(this);
    } else {
      return this.readyView();
    }
  }

  componentDidMount() {
    this.fetchItems()
  }

  fetchItems = () => {
    this.setState({
      fetchState: ApiHelperV2.State.LOADING
    })
    const thisObj = this;
    ApiHelperV2.call(
      { method: 'GET', endPoint: ApiHelperV2.makeUrlPath(['places', this.slug]) },
      function (err, result) {
        if (err) {
          this.setState({
            fetchState: ApiHelperV2.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }
        this.setState({
          items: result,
          cams: result.cams,
          fetchState: ApiHelperV2.State.READY
        })

        if (result && result.cams.length > 0 && !this.state.selectedCam) {
          this.setState({
            selectedCam: result.cams[0],
            selectedCamId: result.cams[0]._id
          }, () => {
            this.updateEvents();
          })
        } else if (result && result.cams.length > 0) {
          for (const c of result.cams) {
            if (c._id === this.state.selectedCamId) {
              this.setState({
                selectedCam: c,
                selectedCamId: c._id
              }, () => {
                this.updateEvents();
              })
            }
          }
        }
      }.bind(this))
  }

  /*onCamSelect() {
    for (const cam of this.state.cams) {
      if (cam._id === this.state.selectedCamId) {
        this.setState({
          selectedCam: cam,
        }, () => {
          this.updateEvents();
        })
      }
    }
  }*/


  updateEvents = (action) => {
    this.getCamEvents(action);
  }

  getCamEvents = (action) => {
    const params = {
      priority: this.eventPriorityValue,
      limit: this.eventsLimit,
    }
    let pageNumber = this.state.pageNumber

    /*const fromEventDateStr = moment(this.state.fromEventDate).format('MM/DD/YYYY, h:mm:ss a')
    const toEventDateStr = moment(this.state.toEventDate).format('MM/DD/YYYY, h:mm:ss a')

    params.fromDateTs = moment(fromEventDateStr, 'MM/DD/YYYY, h:mm:ss a').valueOf()
    params.toDateTs = moment(toEventDateStr, 'MM/DD/YYYY, h:mm:ss a').valueOf()*/

    params.fromDateTs = this.state.fromEventDate
    params.toDateTs = this.state.toEventDate


    if (action === 'next') {
      if(!this.state.paginate) {
        return
      }
      if (this.state.eventDataMain && this.state.eventDataMain.length > 0) {
        pageNumber = pageNumber + 1
        params.pageNumber = pageNumber
      }
    }

    if (action === 'prev') {
      if(this.state.pageNumber === 0) {
        return
      }
      if (this.state.eventDataMain && this.state.eventDataMain.length > 0) {
        pageNumber = pageNumber - 1
        params.pageNumber = pageNumber
      }
    }

    if(!action) {
      pageNumber = 0
    }

    const options = {
      method: 'GET',
      endPoint: ApiHelperV2.makeUrlPath(
        ['cams', this.state.selectedCamId, 'events'],
        params),
    }

    ApiHelperV2.call(
      options,
      function (err, result) {
        if (err) {
          this.setState({
            fetchState: ApiHelperV2.State.ERROR,
            errMsg: Helper.getErrorMsg(err)
          })
          return
        }

        if (result.more) {
          this.setState({
            paginate: true
          })
        } else {
          this.setState({
            paginate: false
          })
        }

        this.fetechedCamEvents = result.items;
        if (this.state.search) {
          this.setState({
            pageNumber: pageNumber,
            eventLatest: (this.fetechedCamEvents.length > 0) ? this.fetechedCamEvents[0] : this.state.eventLatest,
            eventData: this.filterEventsAfterFetch(this.state.search)
          })
        } else {
          this.setState({
            pageNumber: pageNumber,
            eventsReady: true,
            eventLatest: (this.fetechedCamEvents.length > 0) ? this.fetechedCamEvents[0] : this.state.eventLatest,
            eventData: result.items,
            eventDataMain: result.items
          }, () => this.getFilteredCamEvents())
        }
      }.bind(this))
  }

  getFilteredCamEvents = () => {
    const filteredCamEvents = [];

    for (const item of this.state.eventDataMain) {
      if (this.state.eventPriorities.length) {
        if (!this.state.eventPriorities.includes(item.priority)) {
          continue;
        }
      }
      filteredCamEvents.push(item);
    }

    this.setState({ eventData: filteredCamEvents, eventIndex: 0 })

    return filteredCamEvents;
  }

  handleChange = event => {
    this.setState({ [event.target.name]: event.target.value }, () => this.getFilteredCamEvents());
  };

  onCamSelect = event => {
    this.setState({ [event.target.name]: event.target.value }, () => { this.updateEvents() });
  };

  generateSelectField = (formField, data) => {
    return (
      <div className={css(Styles.selectInnerContainer)}>
        <FormControl className={css(Styles.selectInnerContainer)}>
          <InputLabel>{formField.label}</InputLabel>
          <Select
            name={formField.key}
            value={this.state[formField.key]}
            onChange={this.onCamSelect}
          >
            {data.map(item => {
              return (
                <MenuItem value={item._id}>{item.name}</MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </div>
    )
  }

  generateSelectMultiField = (formField, data) => {
    return (
      <div className={css(Styles.selectInnerContainer)}>
        <FormControl className={css(Styles.selectInnerContainer)}>
          <InputLabel>{formField.label}</InputLabel>
          <Select
            name={formField.key}
            multiple
            value={this.state[formField.key]}
            // renderValue={selected => selected.join(', ')}
            renderValue={selected => (
              formField.key === 'eventFields' ?
                this.reportData.eventField.map(events => {
                  return (
                    selected.map(eventSelected => {
                      return (
                        eventSelected === events.keyLabel &&
                        [events.name] + ', '
                      )
                    }))
                }) :
                formField.key === 'eventImages' ?
                  this.reportData.eventImages.map(events => {
                    return (
                      selected.map(eventSelected => {
                        return (
                          eventSelected === events.keyLabel &&
                          [events.name] + ', '
                        )
                      }))
                  }) :
                  this.reportData.eventPriorities.map(events => {
                    return (
                      selected.map(eventSelected => {
                        return (
                          eventSelected === events.keyLabel &&
                          [events.name] + ', '
                        )
                      }))
                  })
            )}
            onChange={this.handleChange}
            classes={{
              select: css(Styles.select)
            }}
          >
            {data.map(item => {
              return (
                <MenuItem value={item.keyLabel} key={item.name}>
                  <Checkbox checked={this.state[formField.key].indexOf(item.keyLabel) > -1} />
                  <ListItemText primary={item.name} />
                </MenuItem>
              )
            })}
          </Select>
        </FormControl>
      </div>
    )
  }


  generateDateField = (formField) => {
    return (
      <div className={css(Styles.selectInnerContainer)}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <DateTimePicker
            id={formField.key}
            name={formField.key}
            className={css(Styles.selectInnerContainer)}
            value={this.state[formField.key] ? momentTz(this.state[formField.key]) : null}
            onChange={e => this.onTimeChange(e, formField.key)}
            label={formField.label}
            // helperText={validity[formField.key] ? '' : '*Required'}
            // error={!validity[formField.key]}
            disableFuture
          />
        </MuiPickersUtilsProvider>
      </div>
    )
  }

  onTimeChange = (e, key) => {
    this.setState({ [key]: moment(e).valueOf() }, () => { this.updateEvents() });
  }

  downloadDialog = () => {
    const eventData = this.getFilteredCamEvents();

    if (eventData.length === 0) {
      this.setState({ downloadDialogErrorTitle: 'Empty list', downloadDialogErrorDesc: 'Empty event list' })
    } else if (this.state.eventFields.length === 0) {
      this.setState({ downloadDialogErrorTitle: 'Empty event field', downloadDialogErrorDesc: 'Please select event fields' })
    }

    this.setState({ downloadDialog: true })
  }

  dialogClose = () => {
    this.setState({
      downloadDialog: false
    }, () => {
      this.setState({
        downloadDialogErrorTitle: '',
        downloadDialogErrorDesc: ''
      })
    })
  }

  makeFileName = () => {
    let fileName;

    const dateExtension = '_ ' +
      'from-' +
      moment(this.state.fromEventDate).format('YYYY') +
      '-' +
      moment(this.state.fromEventDate).format('MM') +
      '-' +
      moment(this.state.fromEventDate).format('DD') +
      '-to-' +
      moment(this.state.toEventDate).format('YYYY') +
      '-' +
      moment(this.state.toEventDate).format('MM') +
      '-' +
      moment(this.state.toEventDate).format('DD')

    if (this.state.selectedCamId) {
      fileName = 'uvs' + '-' + this.state.selectedCamId + dateExtension;
    } else {
      fileName = 'uvs' + '-' + dateExtension;
    }

    return fileName;
  }

  downloadAsExcel = (eventData) => {
    const fileName = this.makeFileName();
    FileDownloadService.prepExcelDownload(
      eventData,
      this.state.eventFields,
      fileName
    );
    this.setState({ downloadDialog: false })
  }

  downloadAsPdf = (eventData) => {
    const fileName = this.makeFileName();
    const columnStyles = {};
    columnStyles['0'] = { cellWidth: 5 };
    this.state.eventFields.forEach((element, index) => {
      columnStyles[index + 1] = { cellWidth: this.pdfAttrColWidth[element] };
    });

    FileDownloadService.prepPdfDownload(
      eventData,
      this.state.eventFields,
      fileName,
      columnStyles
    );
    this.setState({ downloadDialog: false })
  }

  downloadDialogFunction = () => {
    return (
      <Dialog
        onClose={this.dialogClose}
        open={this.state.downloadDialog}
        scroll='paper'
        classes={{
          paperWidthSm: css(Styles.dialog),
          scrollPaper: css(Styles.scrollPaper)
        }}
      >
        <DialogTitle className={css(Styles.dialogTitle)}>
          <p className={css(Styles.dialogTitleContent)}>
            {this.state.downloadDialogErrorTitle ? this.state.downloadDialogErrorTitle : 'Download'} </p>
        </DialogTitle>
        {this.state.downloadDialogErrorTitle &&
          <DialogContent className={css(Styles.dialogContent)}>
            <p className={css(Styles.dialogContentData)}>{this.state.downloadDialogErrorDesc}</p>
          </DialogContent>
        }
        {this.state.downloadDialogErrorTitle &&
          <DialogActions className={css(Styles.dialogActions)}>
            <Button
              variant='contained'
              onClick={this.dialogClose}
              className={css(Styles.dailogActionButton)}>
              OK
            </Button>
          </DialogActions>
        }
        {!this.state.downloadDialogErrorTitle &&
          <DialogActions className={css(Styles.dialogActions)}>
            <Button
              variant='contained'
              onClick={() => this.downloadAsExcel(this.state.eventData)}
              className={css(Styles.dailogActionButton)}>
              Download Excel
            </Button>
            <Button
              variant='contained'
              onClick={() => this.downloadAsPdf(this.state.eventData)}
              className={css(Styles.dailogActionButton)}>
              Download PDF
            </Button>
          </DialogActions>
        }
      </Dialog>
    );
  }

  eventDialog = (item, index) => {
    this.setState({ eventDialog: true, eventIndex: index })
  }

  dialogCloseEvent = (refetch) => {
    this.setState({ eventDialog: false })
    if (refetch) {
      this.updateEvents()
    }
  }

  dialogEdit = event => {
    this.setState({ dialogEdit: event.currentTarget })
  }

  setEventData = (index, priority) => {
    const eventData = this.state.eventData;
    eventData[index].priority = priority;
    this.setState({
      eventData: eventData
    })
  }

  eventImage = (item, img) => {
    const imgArr = [];
    if (img === 'primaryImage') {
      imgArr.push(
        <div className={css(Styles.eventListImageConatiner)}>
          <img src={item.image}
            className={css(Styles.eventImg)}></img>
        </div>
      )
    } else if (img === 'secondaryImage' &&
      item.additionalImages &&
      item.additionalImages.length > 0) {
      imgArr.push(
        <div className={css(Styles.eventListImageConatiner)}>
          <img src={item.additionalImages[0]}
            className={css(Styles.eventImg)}></img>
        </div>
      )
    }
    return imgArr
  }

  eventTable = () => {
    return (
      <Table >
        <TableHead>
          <TableRow className={css(Styles.tableRow)}>
            <TableCell
              align='left'
              className={css(Styles.tableHeader)}>
              SL.No
            </TableCell>
            {this.state.eventFields.length === 0 ?
              this.reportData.eventField.map(events => {
                return (
                  <TableCell
                    align='left'
                    className={css(Styles.tableHeader)}>
                    {events.name}
                  </TableCell>
                )
              })
              :
              this.reportData.eventField.map(events => {
                return (
                  this.state.eventFields.map(eventSelected => {
                    return (
                      eventSelected === events.keyLabel &&
                      <TableCell
                        align='left'
                        className={css(Styles.tableHeader)}>
                        {events.name}
                      </TableCell>
                    )
                  }))
              })
            }
          </TableRow>
        </TableHead>
        <TableBody>
          {this.state.eventFields.length === 0 ?
            this.state.eventData.map((item, index) => {
              return (
                <TableRow className={css(Styles.tableRow)}>
                  <TableCell align='left'>{index + 1 + (this.state.pageNumber * this.eventsLimit)}</TableCell>
                  <TableCell align='left'>{item.camId}</TableCell>
                  <TableCell align='left'>
                    {moment(item.event_time).format('MMM DD, YYYY, h:mm:ss A')}
                  </TableCell>
                  <TableCell align='left'>{item.name}</TableCell>
                  <TableCell align='left'>{AppHelper.getPriorityStr(item.priority)}</TableCell>
                  <TableCell align='left'>{AppHelper.getPriorityStr(item.priorityReported)}</TableCell>
                  <TableCell align='left'>{item.type}</TableCell>
                  <TableCell >
                    {this.state.eventImages.length === 0 ?
                      <div className={css(Styles.eventListImageConatiner)}>
                        <img src={item.image}
                          className={css(Styles.eventImg)}></img>
                      </div>
                      :
                      this.state.eventImages.map(img => {
                        return (
                          this.eventImage(item, img)
                        )
                      })
                    }
                  </TableCell>
                </TableRow>
              )
            })
            :
            this.state.eventData.map((item, index) => {
              return (
                <TableRow className={css(Styles.tableRow)}>
                  <TableCell align='left'>{index}</TableCell>
                  {this.reportData.eventField.map(events => {
                    return (
                      this.state.eventFields.map(eventSelected => {
                        return (
                          events.keyLabel === eventSelected &&
                          this.evenSelectedfunction(item, eventSelected)
                        )
                      })
                    )
                  })}
                </TableRow>
              )
            })
          }
        </TableBody>
      </Table>
    )
  }

  evenSelectedfunction = (item, eventSelected) => {
    if (eventSelected === 'camId') {
      return (
        <TableCell align='left'>
          {item.camId}
        </TableCell>
      )
    }
    else if (eventSelected === 'event_time') {
      return (
        <TableCell align='left'>
          {moment(item.event_time).format('MMM DD, YYYY, h:mm:ss A')}
        </TableCell>
      )
    }
    else if (eventSelected === 'name') {
      return (
        <TableCell align='left'>
          {item.name}
        </TableCell>
      )
    }
    else if (eventSelected === 'priority') {
      return (
        <TableCell align='left'>
          {AppHelper.getPriorityStr(item.priority)}
        </TableCell>
      )
    }
    else if (eventSelected === 'priorityReported') {
      return (
        <TableCell align='left'>
          {AppHelper.getPriorityStr(item.priorityReported)}
        </TableCell>
      )
    }
    else if (eventSelected === 'type') {
      return (
        <TableCell align='left'>
          {item.type}
        </TableCell>
      )
    }
    else {
      return (
        <TableCell align='left'>
          {this.state.eventImages.length === 0 ?
            <div className={css(Styles.eventListImageConatiner)}>
              <img src={item.image}
                className={css(Styles.eventImg)}></img>
            </div>
            :
            this.state.eventImages.map(img => {
              return (
                this.eventImage(item, img)
              )
            })
          }
        </TableCell>
      )
    }
  }

  getEventCount = () => {
    let start, end;
    start = this.state.pageNumber * this.eventsLimit
    end = (this.state.pageNumber) * this.eventsLimit + this.state.eventDataMain.length
    if(this.state.eventDataMain.length > 0) {
      start = start + 1
    }
    return(start + ' to ' + end)
  }

  readyView = () => {
    return (
      <div className={css(CommonStyles.outerContainer)} id='ifmcontentstoprint'>
        <div className={css(Styles.formOuterContainer)}>
          <div className={css(Styles.formNavContainer)}>
            <Link to={{ pathname: '/places' }} className={css(CommonStyles.navLink)} >
              <Icon className={css(CommonStyles.navIcon)} color='secondary' >
            location_city
              </Icon>
              <p className={css(CommonStyles.navTitle)}>Places</p>
            </Link>
            {this.state.items &&
            <p className={css(Styles.headerContainer)}>{this.state.items.name}</p>
            }
          </div>
          <div className={css(Styles.formInnerContainer)}>
            <div className={css(Styles.formContainer)}>
              <div className={css(Styles.formSelectFirstContainer)}>
                {this.generateSelectField(this.reportFields.selectCam, this.state.cams)}
              </div>
              <div className={css(Styles.formSelectSecondContainer)}>
                {this.generateSelectMultiField(this.reportFields.eventFields, this.reportData.eventField)}
              </div>
            </div>
            <div className={css(Styles.formContainer)}>
              <div className={css(Styles.formSelectFirstContainer)}>
                {this.generateDateField(this.reportFields.fromEventDate)}
                <div className={css(Styles.marginRight)}></div>
                {this.generateDateField(this.reportFields.toEventDate)}
              </div>
              <div className={css(Styles.formSelectSecondContainer)}>
                {this.generateSelectMultiField(this.reportFields.eventPriorities, this.reportData.eventPriorities)}
                <div className={css(Styles.marginRight)}></div>
                {this.generateSelectMultiField(this.reportFields.eventImages, this.reportData.eventImages)}
              </div>
            </div>
          </div>
          <div className={css(Styles.eventContainer)}>
            <div className={css(Styles.eventContainerHeader)}>
              <p className={css(Styles.headerContainer)}>Events</p>
              <div className={css(Styles.downloadContainer)}>
                {/*<Tooltip title='Dowload pdf with images'>
                  <Button
                    variant='contained'
                    className={css(Styles.printButton)}
                    onClick={() => window.print()}
                  >
                      PRINT
                  </Button>
                </Tooltip>*/}
                <Tooltip title='Dowload pdf with images'>
                  <IconButton>
                    <Icon className={css(Styles.downloadIcon)} color='secondary' onClick={() => window.print()}>
                      save_alt
                    </Icon>
                  </IconButton>
                </Tooltip>
                <Tooltip title='Dowload pdf/xlsx'>
                  <IconButton>
                    <Icon className={css(Styles.downloadIcon)} color='secondary' onClick={e => this.downloadDialog()}>
                      vertical_align_bottom
                    </Icon>
                  </IconButton>
                </Tooltip>

                {(this.state.paginate || this.state.pageNumber !== 0) &&
                  <div className={css(Styles.paginationContent)}>
                    <Tooltip title='Previous'>
                      <IconButton disabled={this.state.pageNumber === 0}>
                        <Icon className={css(Styles.downloadIcon)} color='secondary' onClick={() => this.updateEvents('prev')}>
                          navigate_before
                        </Icon>
                      </IconButton>
                    </Tooltip>
                    <p className={css(Styles.pageNumber)}>{this.getEventCount()}</p>
                    <Tooltip title='Next'>
                      <IconButton disabled={!this.state.paginate}>
                        <Icon className={css(Styles.downloadIcon)} color='secondary' onClick={() => this.updateEvents('next')}>
                          navigate_next
                        </Icon>
                      </IconButton>
                    </Tooltip>
                  </div>
                }
              </div>
            </div>
            <Divider className={css(Styles.divider)} />
            {/* <EventList
              eventsReady={this.state.eventsReady}
              data={this.state.eventData}
              eventDialog={this.eventDialog} /> */}

            {(this.state.eventData) &&
              this.eventTable()
            }
          </div>
        </div>

        {this.state.downloadDialog &&
          this.downloadDialogFunction()
        }

        {this.state.eventDialog &&
          <EventDialogFunction
            dialogClose={this.dialogCloseEvent}
            eventDialog={this.state.eventDialog}
            eventData={this.state.eventData}
            eventIndex={this.state.eventIndex}
            priority={this.reportData.priorityValues}
            setEventData={this.setEventData}
          />
        }
      </div>
    )
  }
}

const Styles = StyleSheet.create({
  outerContainer: {
    width: '95%',
    display: 'flex',
    flexDirection: 'column'
  },
  formOuterContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  formNavContainer: {
    maxWidth: 130,
    marginBottom: 15,
    display: 'flex'
  },
  formInnerContainer: {
    backgroundColor: AppTheme.secondaryBg,
    padding: 10
  },
  formContainer: {
    display: 'flex',
    flex: 1,
  },
  formSelectFirstContainer: {
    flex: 1,
    marginRight: 30,
    display: 'flex',
  },
  formSelectSecondContainer: {
    display: 'flex',
    flex: 1
  },
  actionButton: {
    backgroundColor: 'white',
    color: 'black',
    fontWeight: 'bolder',
    margin: 0,
    fontSize: 16,
    textTransform: 'unset',
  },
  printButton: {
    backgroundColor: '#303E8A',
    color: 'white',
    fontWeight: 'bolder',
    margin: 0,
    fontSize: 16,
    textTransform: 'unset',
    marginRight: 10
  },
  headerContainer: {
    fontSize: 22,
    fontWeight: 'bold',
    flex: 1,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    flex: 1,
  },
  selectInnerContainer: {
    flex: 1,
    display: 'flex',
    marginTop: 5
  },
  select: {
    ':focus': {
      backgroundColor: AppTheme.secondaryBg
    }
  },
  eventContainer: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: AppTheme.secondaryBg,
    marginTop: 10,
    padding: 10
  },
  eventContainerHeader: {
    display: 'flex',
    alignItems: 'center'
  },
  downloadContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  downloadIcon: {
    borderRadius: '50%',
    color: 'white',
    backgroundColor: '#303E8A',
    padding: 5,
    cursor: 'pointer'
  },
  divider: {
    color: 'white',
    marginTop: 10,
    marginBottom: 10
  },

  dialogTitle: {
    padding: 20,
    paddingBottom: 5
  },
  dialogTitleContent: {
    fontWeight: 600,
    fontSize: 23,
    margin: 0,
    color: 'black'
  },
  dialogContent: {
    padding: 0
  },
  dialogContentData: {
    margin: 0,
    padding: '15px 20px 0px 20px',
    fontWeight: 600
  },
  dialogActions: {
    margin: 20,
    display: 'flex',
    justifyContent: 'flex-start'
  },
  dailogActionButton: {
    backgroundColor: '#303E8A',
    color: 'white',
    fontWeight: 'bolder',
    margin: 0,
    marginRight: 10,
    fontSize: 15,
    textTransform: 'unset'
  },
  link: {
    textDecoration: 'none'
  },
  marginRight: {
    marginRight: 30
  },
  dialog: {
    minWidth: 500,
  },
  errorMsg: {
    color: 'red',
    margin: 0,
    marginRight: 10,
  },
  pageNumber: {
    minWidth: 70,
    textAlign: 'center',
    margin: 0,
    paddingLeft: 5,
    paddingRight: 5
  },
  tableHeader: {
    fontSize: 18,
    fontWeight: 'bold',
    flex: 1,
    minWidth: 'unset',
  },
  tableRow: {
    borderBottom: '2px solid #d6d6d6'
  },
  eventListImageConatiner: {
    width: 100,
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
  eventImg: {
    width: '100%',
    marginTop: 2.5,
    marginBottom: 2.5
  },
  paginationContent: {
    display: 'flex',
    justifyContent: 'flex-end',
    flex: 1,
    alignItems: 'center'
  },
})



// WEBPACK FOOTER //
// ./src/screens/Reports.js